// export const baseUrl = "http://65.0.212.108:8039/api/v1/";
// export const baseUrl = "http://10.0.0.1:8039/api/v1/";
//export const baseUrl = "http://dev.msqube.com/hrms/api/v1/";
//export const baseUrl = "http://localhost:3000/api/v1/";
// export const baseUrl = "http://svchrms.msqube.com/api/v1/";
// export const baseUrl = "https://hrms.msqube.com/api/v1/";
// export const baseUrl = "https://eattendancewb.in/api/v1/";
// export const baseUrl = "https://eattendance.wb.gov.in/api/v1/";
// export const baseUrl = "http://172.25.138.168/api/v1/";
 export const baseUrl = "https://msqtest.eattendancewb.in/api/v1/";

export const environment = {
  app_version: "0.1.0",
  urls: {
    getApkDownloadUrl: "comm/signed-url",
    loginUrl: "login/",
    logoutUrl: "logout",
    generateCaptcha: "generate-captcha",
    changePassword: "changepassword",
    createOrganization: "organization/create/",
    getOrganizationReportColumns: "organization/report-columns",
    createDepartment: "organization/department/create",
    getAllOrganization: "organization/getall",
    getAllDepartment: "organization/department/getall",
    getAllDesignation: "organization/designation/getall",
    getAllServices: "organization/service/getall",
    createEmployeeTiming: "organization/workingshift/create",
    createEmployeeDesignation: "organization/designation/create",
    getAllEmployeeTimingList: "organization/workingshift/getall",
    updateEmployeeShift: "employee/update-shift",
    createEmployeeType: "organization/employeetype/create",
    getAllEmployeeTypeList: "organization/employeetype/getall",
    editDepartmentList: "organization/department/edit",
    editDesignationList: "organization/designation/edit",
    editEmployeeTypeList: "organization/employeetype/edit",
    editEmployeeTimingList: "organization/workingshift/edit",
    DeleteDepertment: "organization/department/delete",
    editOrganizationList: "organization/edit",
    DeleteDesignation: "organization/designation/delete",
    DeleteEmployeeType: "organization/employeetype/delete",
    DeleteEmployeeTiming: "organization/workingshift/delete",
    AllDomainType: "organization/domain/getallbytype",
    getSalaryStructure: "organization/salarystructure/componentgetall",
    getAllCustomer: "customer/getAll",
    AddCustomerPayload: "customer/create",
    editCustomerList: "customer/edit",
    AddSalaryStructure: "organization/salarystructure/create",
    GetAllSalaryStructureList: "organization/salarystructure/getAll",
    AddCandidate: "candidate/create",
    GetSalaryStructureByID: "/organization/salarystructure/getbyid",
    getAllProject: "customer/project/getall",
    AddProjectPayload: "customer/project/create",
    getProjectViewPayload: "customer/project/getbyid/",
    SalaryStructureUpdate: "organization/salarystructure/edit",
    editProject: "customer/project/update",
    getEventcheckStatus: "candidate/getbydeg",
    getRefferal: "candidate/myreferral",
    getEmployeeView: "candidate/getcadbyenroll",
    getAllCandidate: "candidate/allappaliedcandidate",
    getAllEmployee: "employee/getAllemployee/",
    createProjectTask: `ProjectManagement/createTask`,
    getProjectDashboardDetails: "customer/project/dashboard",
    getEmployeeAllDetails: "employee/employeeAllDetails",
    updateAttendancePlatform: "employee/update-attendance-platform",
    updateAutoAttendance: "employee/update-auto-attendance",
    updateAttenFromAnyLocation: "employee/update-atten-from-any-location",
    editEmployee: "candidate/update",
    getMainDashboard: "organization/orgDashboard",
    getLevelDetails: "customer/getleveldetails/",
    editEmployeeDashboard: "employee/update/EmpDetails",
    getAvailableEmp: "customer/project/searchAvailableEmp",
    allocateEmp: "customer/project/allocateEmp",
    getAllPaymentList: "projectbudgeting/projectPayment/getall",
    createProjectPayment: "projectbudgeting/projectPayment/create",
    editProjectPayment: "projectbudgeting/projectPayment/edit",
    deleteProjectPayment: "projectbudgeting/projectPayment/delete",
    editReportingManager: "employee/updatereportingmanager",
    getMyTeamList: "employee/employeelistSupervisor",
    getEmployeeLocations: "employee/getAllemployeeGeoFencing",
    createEmployeeLocation: "employee/createUpdateGeoFencing",
    deleteEmployeeLocation: "employee/deleteGeoFencing",
    addEmployeeImages: "employee/uploadEmpImages",
    getEmployeeImages: "employee/getAllImagesWithEmpId",
    deleteEmployeeImages: "employee/deleteImageById",
    getTimeSheetApprovalDetails: "projectbudgeting/get-timesheet-approval-dtls",

    changeReportingManager: "employee/change-reporting-manager",
    changeReportingManagerBulk: "employee/change-reporting-manager-bulk",
    employeesByReportingManager: "employee/employees-by-reporting-manager",
    changeDesignation: "employee/change-designation",
    changeEmployeeType: "employee/change-employee-type",
    workOrderList: "work-order/list",
    workOrderTotals: "work-order/totals",
    workOrderCreate: "work-order/create",
    workOrderUpdate: "work-order/update",
    workOrderDeactivateEmployees: "work-order/deactivate-employees",
    workOrderReactivate: "work-order/reactivate",
    workOrderDelete: "work-order/delete",
    workOrderOrganizations: "work-order/organizations",
    workOrderEmployeeLog: "work-order/employee-log",
    broadcast: "comm/broadcast",
    broadcastList: "communication/broadcast/list",
    calculateEmpSalary: "candidate/calculateSalaryDetails",
    updateSingleEmpSalary: "candidate/updateSalaryDetails",
    //announcemenet
    createAnnouncement: "organization/annoucement/createEdit",
    deleteAnnouncement: "organization/annoucement/delete",
    // POST
    getAllPostList: "organization/thought/getall",
    createUpdatePost: "organization/thought/createEdit",
    commentOnPost: "organization/postcomment/createEdit",
    getAllCommentOnPost: "organization/postcomment/getall",
    likePost: "organization/postlike/createEdit",
    // Project Budgeting
    getProjectBudgetlist: "projectbudgeting/project/getall",
    getProjectUnbudgetlist: "projectbudgeting/unbudgetproject/getall",
    createProjectBudgeting: "projectbudgeting/project/create",
    editProjectBudgeting: "projectbudgeting/project/edit",
    getBudgetDashboardDetails: "projectbudgeting/budgetDashboard/details",
    updateProjectTask: `ProjectManagement/updateTask`,
    getLoggedInEmployeesTaskList: `ProjectManagement/getEmpTask`,

    // Project Expense Management
    getProjectListsForExpense:
      "projectbudgeting/proj-expense/project-list-for-expense",
    getProjectExpenseHead:
      "projectbudgeting/proj-expense/project-expense-heads",
    createProjectExpense: "projectbudgeting/proj-expense/create-expense",
    getMyExpenseLists: "projectbudgeting/proj-expense/my-expense-list",
    allExpenseLists: "projectbudgeting/proj-expense/all-expense-list",
    expenseDetails: "projectbudgeting/proj-expense/expense-details",
    pendingExpenseApproval: "projectbudgeting/proj-expense/pending-approval",
    approveProjectExpense: "projectbudgeting/proj-expense/approve-expense",
    candidateListAgainstStatus: "candidate/unprocessed-candidate-list",
    salaryDetailsGivenForWaitingCandidate: "candidate/send-cand-for-approval",
    SendOfferMailToCandidate: "candidate/send-offer-accept-mail",
    GetOfferMailToCandidate: "candidate/get-offer-details",
    GetSalaryDetailsForApproval: "candidate/sal-mngr-dtls-by-cand",
    userCreationFromOnboarding: "candidate/create-employee",
    // POST
    AddPost: "organization/post/create/",
    getAllPost: "organization/post/getall/",
    deletePost: "organization/post/delete/",
    editPost: "organization/post/edit/",
    // salary component
    AddSalaryComponent: "organization/salarycomponent/create/",
    SalarycomponentGetAllurl: "organization/salarycomponent/getall/",
    DeleteSalaryComponent: "organization/salarycomponent/delete/",
    editSalaryComponent: "organization/salarycomponent/edit/",
    sampleSalarydownload: "salary/getDummyPdf",
    divisionGetAllUrl: "customer/division/getall",
    subDivisionGetALLUrl: "customer/subdivision/getall",
    //common
    fileUploadUrl: "comm/file/upload",
    downloadFileUrl: "comm/file/download",
    getAllBankList: "comm/bank_master/getall",

    //doc
    fileUploadDocument: "employee/uploadEmpFiles",
    getMyDocument: "employee/fetchEmpDocs",
    deleteMyDocument: "employee/deleteEmpDoc",
    downloadMyDocument: "employee/file/download",

    //attendance
    downloadAttendance: "employee/downloadattendence/template/",
    attendanceDashboard: "employee/attendence/dashboard/",
    attendenceUploadUrl: "employee/uploadattendence",
    attendenceStatus: "customer/project/dashboard/attendence_status",
    //attendance
    pendingAprovalList: "employee/attendencelist/bydesignation",
    uploadedattendanceexcelview: "employee/employeelist/byattendence",

    // Attendence New
    getDayWiseEmpAttendence: "employee-attendance/daywise-attendance",
    getAllEmpAttendenceMonthly:
      "employee-attendance/get-org-monthly-attendance",
    monthwiseEmpAttendenceDetails:
      "employee-attendance/get-empwise-maonthly-attendance",
    sendForApproval: "employee-attendance/send-atten-approval",
    viewTeamAttendence: "employee-attendance/team-attendance",
    pendingAttendenceList: "employee-attendance/atten-approval-reqs",
    ediAttendence: "employee-attendance/edit-attendance",
    attendanceApproval: "employee-attendance/approve-attendance",
    myAttendance: "employee-attendance/emp-attendance",
    getEmpWiseYearlyAttendance:
      "employee-attendance/get-empwise-yearly-attendance",
    attendanceDownloadExcel: "employee-attendance/download-attendance-report",
    attendanceFailures: "attendance-failures",
    generateAttendanceReportPdf:
      "employee-attendance/generate-attendance-report-pdf",
    attendanceReportList: "employee-attendance/attendance-report-list",
    downloadAttendanceReport: "employee-attendance/download-report",
    futureAttendanceApprovalList:
      "employee-attendance/future-attendance-approval/list",
    futureAttendanceApprovalUpdateStatus:
      "employee-attendance/future-attendance-approval/update-status",
    fetchEmpAttendance: "employee-attendance/fetch-emp-attendance",
    updateEmpAttendance: "employee-attendance/update-emp-attendance",
    updateEmployeeId: "employee/update-employee-id",
    daywiseAttendanceReportGenerate:
      "employee-attendance/daywise-attendance-report/generate",
    daywiseAttendanceReportList:
      "employee-attendance/daywise-attendance-report/list",
    daywiseAttendanceReportDownload:
      "employee-attendance/daywise-attendance-report/download",
    empDaywiseAttendanceReportDownload:
      "employee-attendance/emp-daywise-attendance-report/download",
    // New Service - Payroll
    payrollResetAndSync: "payroll/empAttendenReset",
    //  dummy urls
    uploadBulkEmployee: "employee/",

    reportingmanagerGetUrl: "employee/employeebyproject",
    employeeByOrgWithParents: "employee/employeebyorgwithparents",
    forceLogoutOrganization: "employee/force-logout-organization",
    getAllOrgsForReportingManager:
      "organization/get-all-orgs-for-reporting-mngr",
    getAllReportingManagers: "organization/get-all-reporting-managers",
    candidateApproveUrl: "candidate/approveCandidateDetails",
    actionStatusUrl: "comm/checkActionStatus",
    updateAttendance: "employee/update/employeeattendence/",
    attendanceApproveList: "employee/attendencelist",
    payrollAvalibleEmployeeUrl: "payroll/employeeAvaialbleList",
    generatePayrollBatchUrl: "payroll/generatemonthlyPayroll",
    batchListUrl: "payroll/batchList",
    PaymentBatchDetailUrl: "payroll/employeeData",
    updateAttendanceApproval: "employee/update/attendence",
    GetSalaryCalculatedComponet: "payroll/calculatedcomponentbyemployee",
    releaseBatchUrl: "payroll/releaseBatch",
    UpdatePayrollComponent: "payroll/employeeComponentUpdate",
    BatchUpdateUrl: "payroll/batchUpdate",
    BatchByDegUrl: "payroll/batchListbydeg",
    projectAttendaceTemplate: "comm/templatefield/getall",
    getAllLevelsForProject: "comm/level_master/getall",
    getBatchDataByProject: "customer/project/dashboard/batchdata",
    getEmpPayrollByProjectId: "customer/project/dashboard/employee_payroll",
    editAssoiciationStatus:
      "customer/project/dashboard/association_status/edit",
    deleteEmployeeAttendanceFromBatch: "employee/delete/employeeattendence",
    downloadRTGSNEFT: "payroll/neftRtgsForm",
    getAllAccessControl: "users/getallaccesscontrolmaster",
    createRole: "users/createrole",
    getAllRoleMasterList: "users/getallrole",
    getRoleByID: "users/getrolebyid",
    updateRole: "users/updaterole",
    userRoleMapping: "users/userList",
    roleAssignToUser: "users/assignroletouser",
    getLevelStructure: "customer/project/getleveltreebyid",
    getLevelTargetRateValue: "customer/project/get/targetratevalue",
    downloadEmpSalarySlip: "salary/getEmployeePaySlip",
    downloadBatchWisePayslipZip: "salary/getPayslipZip",
    downloadBulkCandidateForm: "candidate/downloadbulkexcel",
    getBulkUploadCandidate: "candidate/getbulkuploadstatus",
    getBulkEmployeeUpload: "candidate/bulkcreate",
    getFilteredBulkStatus: "candidate/getbulkstatus/byIds",
    getbulkuploadreport: "candidate/bulkupload/getreport",
    candidateBulkCreateList: "candidate/bulkcreate/list",
    candidateBulkCreateStatus: "candidate/bulkcreate/status/",
    getOrgBulkStatus: "organization/bulkupload/status",
    getOrgBulkStatusById: "organization/bulkupload/status/",
    downloadOrgBulkTemplate: "organization/bulkupload/template",
    uploadOrgBulk: "organization/bulkupload",
    downloadOrgBulkFile: "organization/bulkupload/download/",
    getemployeelistbyexcel: "employee/getemployeelistbyexcel",
    getAllUsersByOrganization: "lifecycle/getAll",
    createLifeCycle: "lifecycle/create",
    attendanceDashboardUrl: "employee-attendance/org-head-dashboard",
    orgHeadDashboardSnapshotUrl:
      "employee-attendance/org-head-dashboard/snapshot",
    orgHeadDashboardClassificationUrl:
      "employee-attendance/org-head-dashboard/classification",
    orgHeadDashboardTopListsUrl:
      "employee-attendance/org-head-dashboard/top-lists",
    orgHeadDashboardEmployeesUrl:
      "employee-attendance/org-head-dashboard/employees",
    organizationReportCsv: "organization/report/csv",
    organizationReportData: "organization/report/data",
    submitTodaysTimesheet: "projectbudgeting/updatemonthlytimeshift",
    terminateBatchInitiate: `employee/terminatebatch/async`,
    // leave type env url

    LeaveTypeGetAll: "leave/leavetype/getall",
    GetLeaveTypeById: "leave/leavetype/byid",
    EditLeaveType: "leave/leavetype/edit",
    DeleteLeaveType: `leave/leavetype/byid/delete`,
    createLeaveType: `leave/leavetype/create`,
    getAllTodaysProjectForTimesheet: "employee/get-emp-project-timesheet",

    // organization holiday env url

    addHoliday: "leave/addholiday",
    deleteHoliday: "leave/deleteholiday",
    holidayList: "leave/holidaylist",
    holidayById: "leave/holiday/byid",
    editHoliday: "leave/editholiday",
    empTimeSheetProjectwise: `projectbudgeting/emp-timesheet-projectwise`,
    giveAttendanceApp: `employee-attendance/give-attendance-app`,
    appDashboard: "employee/app-dashboard",
    // leave management env url

    createLeaveManagement: "leave/leavemanagement/create",
    getAllLeaveManagement: "leave/leavemanagement/getall",
    editLeaveManagement: "leave/leavemanagement/edit",
    deleteLeaveManagement: "leave/leavemanagement/delete",
    designationWiseLeaveCount: "leave/getnoofleave/designationwise",
    leaveDetailsDesignationWise: "leave/designationwise/leavedetails",
    designationwiseleavedetails: "leave/designationwise/leavedetails",
    getEmployeeByDesignation:
      "leave/leaveapplication/getEmployee/bydesignation",
    calculateLeaveDays: "leave/leaveapplication/calculate/leavedays",
    getLeaveTypeAmountData: "leave/leaveapplication/getleave",
    applyLeave: "leave/leaveapplication/applyLeave",
    getLeaveDetails: "leave/leaveapplication/getleavedata",
    getAllLeaveApprovalList: "leave/leaveapplication/getleavebydeg",
    updateLeaveApproveStatus: "leave/leaveapplication/update",
    leaveDetailsData: "leave/leaveapplication/getleavedatedetails",
    allLeaveList: "leave/leavemanagement/getallleave/",
    updateLeave: "leave/leaveapplication/edit",
    getLeaveDetailsForDashboard: "leave/leaveapplication/getDetails/dashboard",
    getMyTeamsLeaves: "leave/leavemanagement/get-my-team-leaves/",
    getLeaveSummary: "leave/leavemanagement/get-all-employee-leave",
    // Timing Sheet env url
    getTimesheetList: "/projectbudgeting/timesheetprojectget",
    getTimeSheetPendingApprovalList: "/projectbudgeting/pendingapproval",
    updateTimingSheetApproveStatus: "/projectbudgeting/approverequest",
    updateMonthlyTimeSheet: "projectbudgeting/updatemonthlytimeshift",
    initiateTimeSheet: "projectbudgeting/initiatetimesheet",
    getAllStates: "comm/states",
    employeeSearchByName: "employee/searchbyemployeeidorname",
    cancelLeave: `leave/leaveapplication/cancelleave`,
    getStateByAddressId: `employee/getStateByAddress`,
    getHolidayByEmployee: `leave/leaveapplication/getholidaylistbyemployee`,
    pfesicMonthlyReportLists: "payroll/pfesicmonthlyreport",
    naturalHolidays: `leave/leaveapplication/naturalholidaylist`,
    syncSalaryStructureForEmp: "organization/syncemployeesalary",
    levelMasterGetAll: "customer/levelmaster/getall",
    empWiseTimesheetDetails: "employee/getAllEmpTimeSheet",
    getEmpAttendanceMonthly: "/employee/getEmpAttandanceMonthly",

    //Levels env url
    getLevels: "/customer/level/getbymaster",
    addLevelMaster: "customer/levelmaster/create",
    editLevelMaster: "customer/levelmaster/update",
    getLevelByMaster: "customer/level/getbymaster",
    createLevel: "customer/level/update",
    attendanceTimeSheet: "employee/timesheet/calculateattendance",
    uploadAttendanceTimeSheet: "employee/timesheet/uploadattendancebytimesheet",
    payrollReport: "salary/salaryreport",
    thresholdParameter: "comm/parameters/getall",
    timeSheetHistory: "projectbudgeting/timesheet/getall",
    resetpasswordrequest: "users/resetpasswordrequest",
    employeeTransfer: "employee/transfer",
    employeeTransferRequests: "employee/transfer-requests",
    activeInactiveEmployee: "user/active-inactive",
    promotionlist: "promotion/promotionlist",
    viewPromotionDetails: "promotion/promotiondetails",
    promotionPendingApproval: "promotion/promotionbydeg",
    initiatePromotion: "promotion/initiatepromotion",
    editPromotion: "promotion/edit-req",
    updatePromotion: "promotion/updatepromotion",
    deletePromotion: "promotion/deletepromotion",
    empAvailableListForPromotion: "promotion/availableemplist",
    activateSalaryForPromotion: "promotion/activepromotionbatch",
    consolidatedReportForProject:
      "projectbudgeting/budgetDashboard/consolidatedReport",
    monthWiseEmpSalary: "projectbudgeting/monthEmployeeSalary",
    empMonthlySalaryProjectwise: "projectbudgeting/projectEmployeeSalary",

    //Termination
    getAllEmployeeListAvailableForTermination:
      "employee/emplistfortermination/",
    initiateTermination: "employee/initiatetermination/",
    terminationInitiatedEmployeeList: "employee/terminationlistbydeg/",
    terminatedEmployeeList: "employee/terminatedemployeelist/",
    approveTermination: "employee/terminationapproval/",

    //Project Closure
    getAllAvailableProjectForTermination: "projectbudgeting/activeprojectlist/",
    initiateProjectClosure: "projectbudgeting/initiateProjectClosure/",
    projectClosureInitiatedList: "projectbudgeting/pendingProjectClosure/",
    projectClosureApproval: "projectbudgeting/completeProjectClosure/",
    completedProjectList: "projectbudgeting/completeprojectlist",

    //Project report
    consolidatedReportDownload:
      "projectbudgeting/budgetDashboard/consolidatedReportExcel",
    consolidatedMonthlyReportProjectwise:
      "projectbudgeting/budgetDashboard/consolidatedMonthEmpReport",
    paymentAgainstExpense:
      "projectbudgeting/proj-expense/all-approved-expenses",
    expenseMarkAsPaid: "projectbudgeting/proj-expense/mark-as-paid",

    // Invoice
    invoiceList: "projectbudgeting/projectPaymentinvoice/getall",
    createInvoice: "projectbudgeting/projectPaymentinvoice/create",
    editInvoice: "projectbudgeting/projectPaymentinvoice/edit",

    createTimeline: `ProjectManagement/createTimeline`,
    getProjectTimelineByProjectId: `ProjectManagement/getTimelineByProjectId`,
    getStoryStatusURL: `ProjectManagement/getStoryStatus`,
    getTaskListByProjectURL: `ProjectManagement/getTask`,
    changeStatusOfTask: `ProjectManagement/changeStatus`,
    getEmpTaskOfEmployee: `ProjectManagement/getEmpTask`,
    // Timeline
    getAlltimelineUrl: "ProjectManagement/projectTreeStructure",
    // Notification
    getAllNotification: "comm/get-all-notifications",
    seenNotification: "comm/seen-notification",
    sendPasswordResetOtp: "users/send-password-reset-otp",
    verifyOtpResetPassword: "users/verify-otp-reset-password",
    signedOfferLetterUpload: "employee/signed-offer-letter-approval",
    offerLetterSignedList: "employee/offer-signed-copy-by-deg",
    offerLetterApproval: "employee/process-ol-req",
    getAllTermCondition: "candidate/term-Condition/getAll",
    updateTermCondition: "candidate/term-condition/employee-termAndCondition",
    getAllAnnouncement: "organization/annoucement/getall",
    // Organogram
    getOrganogram: "organization/organogram",
    getOrgChart: "organization/chart",

    feedbackManagerPendingAlert: "feedback/manager/pending-alert",
    feedbackManagerPendingFeedback: "feedback/manager/pending-feedback",
    feedbackManagerSubmittedFeedback: "feedback/manager/submitted-feedback",
    feedbackManagerSentBackFeedback: "feedback/manager/sent-back-feedback",
    feedbackManagerSaveDraft: "feedback/manager/feedback/save-draft",
    feedbackManagerSubmit: "feedback/manager/feedback/submit",
    feedbackManagerFeedbackDetail: "feedback/manager/feedback",
    feedbackReportingManagerPendingApproval:
      "feedback/reporting-manager/pending-approval",
    feedbackReportingManagerApproved: "feedback/reporting-manager/approved",
    feedbackReportingManagerRejected: "feedback/reporting-manager/rejected",
    feedbackReportingManagerFeedbackDetail: "feedback/reporting-manager",
    feedbackAnnualConsolidate: "feedback/annual/consolidate",
    feedbackAnnualDashboard: "feedback/annual/dashboard",
    feedbackAnnualDetail: "feedback/annual",
    feedbackIncrementSlabs: "feedback/increment-slabs",
    feedbackPermissions: "feedback/permissions",
    feedbackMyPermissions: "feedback/my-permissions",
    reportingManagerDetailsURL: `feedback/reporting-manager/detail`,
    promotionListAsync: "promotion/active-promotion-batch-async",
    releaseLeterPDF: `employee/resend-release-letter/`,
    reportingManagerApproveURL: `feedback/reporting-manager/approve`,
    reportingManagerRejectURL: `feedback/reporting-manager/reject`,
    GetPermissionDetails: "feedback/permissions/me",
    getFeedbackEmployeeProjects: `feedback/manager/employee/`,
    feedbackSaveDraft: `feedback/manager/feedback/save-draft`,
    feedbackSubmit: `feedback/manager/feedback/submit`,
    checkEmployeeCTC: `feedback/ceo-review/check-emp-ctc`,
  },
  sideNav: [
    {
      key: "dashboard",
      name: "Dashboard",
      sub_title: "",
      icon: "dashboard",
      has_submenu: false,
      url: "/dashboard/dashboard-main/",
      menuItem: [],
      sub_url: [],
      actionOptionsOuter: [],
    },
    {
      key: "organization_management",
      name: "Organization",
      icon: "business",
      has_submenu: true,
      sub_title: "",
      url: "/organization/",
      sub_url: [],
      actionOptionsOuter: [],
      menuItem: [
        {
          key: "setup_organization",
          item_name: "Organization",
          icon: "add_circle_outline",
          url: "/organization/organization-main/",
          sub_title: "Manage your organization as per your need.",
          sub_url: ["organization/add-organization-new/"],
          actionOptionsOuter: [
            { key: "org_update", value: "Update Org." },
            { key: "liveliness_check", value: "Liveliness Check" },
            { key: "late_present", value: "Late Present Check" },
            {
              key: "future_attendance_approval",
              value: "Future Attendance Approval",
            },
            { key: "erly_chkout", value: "Restricted Attendance" },
            { key: "org_emp_logout", value: "Organization Force Logout" },
          ],
        },
        {
          key: "setup_department",
          item_name: "Department ",
          icon: "supervisor_account",
          url: "/organization/setup-department/",
          sub_title: "Department is a part of your organization",
          sub_url: ["/organization/add-department/"],
          actionOptionsOuter: [{ key: "dept_update", value: "Update Dept." }],
        },
        {
          key: "setup_employee_type",
          item_name: "Employee Type ",
          icon: "format_list_bulleted",
          url: "/organization/employee-type-list/",
          sub_title: "Customise your setup to best fit your team",
          sub_url: ["/organization/setup-employee-type/"],
          actionOptionsOuter: [
            { key: "emp_type_update", value: "Update Emp. Type" },
          ],
        },
        {
          key: "setup_designation",
          item_name: "Designation ",
          icon: "award",
          url: "/organization/setup-designation/",
          sub_url: ["/organization/add-designation/"],
          sub_title: "Customise your team based on their role and experience",
          actionOptionsOuter: [{ key: "desig_update", value: "Update Desig." }],
        },
        {
          key: "bulk_upload_organization",
          item_name: "Organization Bulk Upload ",
          icon: "upload",
          url: "/organization/organization-bulk-upload/",
          sub_url: [],
          sub_title: "Organization Bulk Upload",
          actionOptionsOuter: [],
        },
        // {
        //   key: "setup_salary_structure",
        //   item_name: "Salary Structure",
        //   icon: "payments",
        //   url: "/organization/salary-structure-list/",
        //   sub_title:
        //     "Salary structure includes the details of the salary being offered",
        //   sub_url: [
        //     "/organization/add-salary-structure",
        //     "/organization/edit-salary-structure/",
        //   ],
        //   actionOptionsOuter: [
        //     { key: "salary_struct_update", value: "Update Sal. Str." },
        //     { key: "salary_struct_sync", value: "Salary Sync." },
        //   ],
        // },
        // {
        //   key: "salary_component",
        //   item_name: "Salary Component",
        //   icon: "payment",
        //   url: "/organization/salary-component/",
        //   sub_title: "Salary components are base of any structure",
        //   sub_url: ["/organization/add-salary-component"],
        //   actionOptionsOuter: [
        //     { key: "salary_comp_update", value: "Update Sal. Comp." },
        //   ],
        // },
        {
          key: "setup_employee_timing",
          item_name: "Employee Timing ",
          icon: "schedule",
          url: "/organization/employee-timing-list/",
          sub_title:
            "The period during which an employee is available for employment.",
          sub_url: ["/organization/add-employee-timing/"],
          actionOptionsOuter: [
            { key: "emp_timing_update", value: "Update Emp.Timing" },
          ],
        },
        {
          key: "workorder_dashboard",
          item_name: "WorkOrder Dashboard ",
          icon: "work_order",
          url: "/organization/work-order-dashboard/",
          sub_title: "Track and manage client work orders.",
          sub_url: [],
          actionOptionsOuter: [
            { key: "edit_workorder", value: "Edit WorkOrder" },
            { key: "extra_employee", value: "Edit Extra Employees" },
            { key: "toggle_workorder", value: "Toggle WorkOrder" },
            { key: "del_workorder", value: "Delete WorkOrder" },
          ],
        },
        {
          key: "broadcasting",
          item_name: "Broadcast Management",
          icon: "broadcast",
          url: "/organization/broadcast-management/",
          sub_title:
            "Broadcast a message to organizations over email, push, and in-app.",
          sub_url: [],
          actionOptionsOuter: [],
        },
        // {
        //   key: "announcement",
        //   item_name: "Announcement",
        //   icon: "announcement",
        //   url: "/organization/announcement_list/",
        //   sub_title: "Stay updated with the latest news and important updates.",
        //   sub_url: ["/organization/add-announcement/"],
        // },
      ],
    },
    {
      key: "employee_management",
      name: "Employee",
      icon: "people",
      has_submenu: true,
      url: "/employment/",
      sub_title: "",
      sub_url: [],
      actionOptionsOuter: [],
      menuItem: [
        {
          key: "employee_list",
          item_name: "Employee List",
          icon: "toc",
          url: "/employment/employee-list/",
          sub_title: "Organization's employee details list",
          sub_url: ["/employment/manage-profile/"],
          actionOptionsOuter: [
            { key: "emp_transfer_req", value: "Transfer Employee" },
            { key: "emp_active_inactive", value: "Active/Inactive Employee" },
            { key: "reset_login_attempt", value: "Reset Login Attempts" },
            { key: "reset_logout", value: "Force Logout" },
            // { key: "emp_details_password", value: "Change Password" },
            // { key: "emp_details_image", value: "Change Image" },
            // { key: "emp_details_geo_loc", value: "Geo Location" },
            // { key: "view_emp_salary", value: "View Salary Details" },
          ],
        },
        {
          key: "employee_detail",
          item_name: "Employee Detail",
          icon: "toc",
          url: "/employment/manage-profile/",
          sub_title: "",
          sub_url: [],
          isnotmenu: true,
          actionOptionsOuter: [
            { key: "emp_details_password", value: "Change Password" },
            { key: "emp_details_image", value: "Change Image" },
            { key: "emp_details_geo_loc", value: "Geo Location" },
            { key: "view_emp_salary", value: "View Salary Details" },
            { key: "update_documents", value: "Update Documents" },
            { key: "pf_esic_toggle", value: "PF & ESIC Applicable" },
            {
              key: "update_reporting_manager",
              value: "Update Reporting Manager",
            },
            { key: "desig_type_update", value: "Update Designation & Employee Type" },
            { key: "shift_update", value: "Shift Update" },
            { key: "attendance_plat", value: "Attendance Platform" },
            { key: "auto_attend", value: "Auto Attendance Check" },
            { key: "geo_loc_check", value: "Off Geo Location Check" },
          ],
        },
        {
          key: "add_employee",
          item_name: "Onboard Employee",
          icon: "add",
          url: "/employment/add-employee/",
          sub_title: "Onboarding a new candidate ",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "bulk_upload_employee",
          item_name: "Bulk Onboard",
          icon: "user_plus",
          url: "/employment/bulk-upload-employee/",
          sub_title: "Onboarding new candidates in Bulk ",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "onboard_request",
          item_name: "Pending Approval",
          icon: "pending_action",
          url: "/employment/onboarding-request-app-rej/",
          sub_title:
            "Onboarding candidate's request approval or rejection list",
          sub_url: ["/employment/send-mail/"],
          actionOptionsOuter: [
            { key: "view_candidate_details", value: "View Candidate Details" },
            { key: "approve_candidate", value: "Approve Candidate" },
            { key: "user_creation", value: "User Creation" },
            { key: "send_mail", value: "Send Offer Letter" },
          ],
        },
        {
          key: "referral_list",
          item_name: "My Referral",
          icon: "supervisor_account",
          url: "/employment/referral-list/",
          sub_title: "New Candidate referred by the user ",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "candidate_list",
          item_name: "All Candidate",
          icon: "collections_bookmark",
          url: "/employment/all-candidate/",
          sub_title: "candidate's details list",
          sub_url: ["/employment/candidate_details/"],
          actionOptionsOuter: [],
        },
        // {
        //   key: "approval_list",
        //   item_name: "Approval List",
        //   icon: "supervisor_account",
        //   url: "/employment/approval-list/",
        //   sub_title: "",
        //   sub_url: [],
        // },
        {
          key: "my_team",
          item_name: "My Team",
          icon: "supervisor_account",
          url: "/employment/my-team/",
          sub_title: "",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "employee_transfer",
          item_name: "Transfer",
          icon: "compare_arrows",
          url: "/employment/employee-transfer/",
          sub_title: "Employee transfer requests",
          sub_url: [],
        },
        {
          key: "bulk_reprt_manager",
          item_name: "Bulk Change Reporting Manager",
          icon: "supervisor_account",
          url: "/employment/bulk-change-reporting-manager/",
          sub_title: "Re-assign employees to another reporting manager in bulk",
          sub_url: [],
          actionOptionsOuter: [],
        },
      ],
    },
    {
      key: "attendance_management",
      name: "Attendance",
      icon: "fingerprint",
      has_submenu: true,
      url: "/attendance/",
      sub_title: "",
      sub_url: [],
      actionOptionsOuter: [],
      menuItem: [
        {
          key: "attendance_dashboard",
          item_name: "Attendance Dashboard",
          icon: "dashboard",
          url: "/attendance/attendance_dashboard/",
          sub_title: "Attendance Dashboard",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "all_emp_attendence",
          item_name: "All Attendance",
          icon: "apps",
          url: "/attendance/all-emp-attendence/",
          sub_title: "All Employee Attendence",
          sub_url: ["/attendance/emp-attendence-details"],
          actionOptionsOuter: [],
        },
        {
          key: "atten_altr",
          item_name: "Attendance Alter",
          icon: "schedule",
          url: "/attendance/attendance-alter/",
          sub_title: "Attendance Alter & Update",
          sub_url: ["/attendance/attendance-update"],
          actionOptionsOuter: [],
        },
        {
          key: "team_attendence",
          item_name: "Team Attendance",
          icon: "summarize",
          url: "/attendance/team-attendence/",
          sub_title: "Team Attendence",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "my_attendence",
          item_name: "My Attendance",
          icon: "punch_clock",
          url: "/attendance/my-attendence/",
          sub_title: "My Attendence",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "attendence_pending_approval",
          item_name: "Pending Approval",
          icon: "priority_high",
          url: "/attendance/attendence-pending-approval/",
          sub_title: "Pending Approval",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "failed_attendance",
          item_name: "Failed Attendance",
          icon: "Wrong_attendance",
          url: "/attendance/failed-attendance/",
          sub_title: "Attendance failure audit logs",
          sub_url: [],
          actionOptionsOuter: [
            { key: "view_failure_details", value: "View Failure Details" },
          ],
        },
        {
          key: "daily_attendace_rprt",
          item_name: "Download Daily Attendance",
          icon: "attendance_download",
          url: "/attendance/download-daily-attendance/",
          sub_title: "Download Daily Attendance Reports",
          sub_url: [],
          actionOptionsOuter: [
            { key: "daywise_atten_btn", value: "Download Daywise Attendance" },
          ],
        },
        {
          key: "month_attendence_reprt",
          item_name: "Download Monthly Attendance",
          icon: "download",
          url: "/attendance/monthly-attendance/",
          sub_title: "Download Monthly Attendance Reports",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "attendance_report",
          item_name: "Attendance Report",
          icon: "report",
          url: "/attendance/attendance-report/",
          sub_title: "Organization-wise attendance report",
          sub_url: [],
          actionOptionsOuter: [],
        },
      ],
    },
    {
      key: "user_management",
      name: "User Management",
      icon: "manage_accounts",
      has_submenu: true,
      sub_title: "",
      url: "/usermanagement/",
      sub_url: [],
      actionOptionsOuter: [],
      menuItem: [
        {
          key: "role_master",
          item_name: "Role Master",
          icon: "role_master",
          url: "/usermanagement/role-master/",
          sub_title: "Create Role of the employee...",
          sub_url: ["usermanagement/add-role/"],
          actionOptionsOuter: [],
        },
        {
          key: "user_role_mapping",
          item_name: "User Role Mapping",
          icon: "user_role_mapping",
          url: "/usermanagement/user-role-mapping/",
          sub_title: "User Role Mapping for employee...",
          sub_url: [],
          actionOptionsOuter: [],
        },
        {
          key: "user-list-view",
          item_name: "Life Cycle Management",
          icon: "life_cycle_management",
          url: "/usermanagement/user-list-view/",
          sub_title: "Life Cycle Management for employee...",
          sub_url: ["usermanagement/life-cycle-management/"],
          actionOptionsOuter: [],
        },
      ],
    },
  ],

  autoApprovedEventType: [12, 2, 9, 8],

  global_veriable: {
    emp_type_for_project_specific: 20,
    OnBoardingeventType: 1,
    ho_employees_type_id: [21, 19],
    ho_project_name: "HO Internal",
    officialEmployee: [24, 25, 26, 31, 32, 33, 42],
    managerLevelDeg: [26],
    superAdminLevel: [24, 25, 31, 33],
    exceptSupTypeLevelDeg: [27, 28, 29, 30, 32, 33],
  },
  event_action_items: [
    { key: "salary_assignment", value: "Assign Salary" },
    { key: "reporting_manager", value: "Assign Reporting Manager" },
    { key: "user_creation", value: "" },
    { key: "intermediate_approval", value: "Intermediate Approval" },
    { key: "final_approval", value: "Final Approval" },
    { key: "approve", value: "Approve" },
  ],
  leave_application: {
    permanent_holiday: [0],
    leave_apply_limit: 6,
    leave_difference: 180,
    sick_leave: 3,
    casual_leave: 1,
    previlage_leave: 9,
    earn_leave: 4,
    non_deltable_leave: [8, 9, 10],
    holiday_sat: [2, 4],
  },
  promotion_details: {
    revision_start: 3, // for promotion and revision both case
  },
};

export const regexMapper = {
  GSTRegex:
    /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
  IFSCCodeRegex: /^[A-Za-z]{4}0[A-Z0-9]{6}$/,
  PANRegex: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  EmailRegex:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  checkPANIsValid(value: any): boolean {
    return this.PANRegex.test(value);
  },
  checkIFSCCodeValid(value: any) {
    return this.IFSCCodeRegex.test(value);
  },
  checkEmailIsValid(value: any) {
    return this.EmailRegex.test(value);
  },
  checkGSTIsValid(value: any): boolean {
    return this.GSTRegex.test(value);
  },
};

export const holi_days_system = [
  { key: "sun_day", value: "Sunday" },
  { key: "mon_day", value: "Monday" },
  { key: "tues_day", value: "Tuesday" },
  { key: "wednes_day", value: "Wednesday" },
  { key: "thurs_day", value: "Thursday" },
  { key: "fri_day", value: "Friday" },
  { key: "satur_day", value: "Saturday" },
];

export const COOLDOWN_DURATION_MS = 5 * 60 * 1000; // 5 minutes in milliseconds
export const COOLDOWN_STORAGE_KEY = "promotion_reinitiate_last_clicked";
export const COOLDOWN_STORAGE_KEY_TERMINATION =
  "termination_reinitiate_last_clicked";

